let defaultTheme = {
	name: "Default",
	page: {
		backgroundColor: "rgba(0,0,0,1)",
		backgroundImageUrl: "",
		backgroundGradient: null,
		paddingVertical: "10",
		paddingHorizontal: "10",
	},
	navBar: {
		color: "rgba(255,255,255,1)",
		backgroundColor: "rgba(0,0,0,1)",
	},
	tabBar: {
		borderStyle: "solid",
		borderColor: "rgba(255,255,255,1)",
		borderWidth: "1",
		backgroundColor: "rgba(0,0,0,0)",
		backgroundImageUrl: "",
		backgroundGradient: null,
		text: {
			family: "Lato-Bold",
			size: "16",
			italic: false,
			underline: false,
			lineHeight: "30",
			color: "rgba(255,0,0,1)",
			uppercase: false,
			letterSpacing: "1",
			textShadow: null,
		},
	},
	navigation: {
		title: {
			family: "Lato-Bold",
			size: "24",
			italic: false,
			underline: false,
			lineHeight: "30",
			color: "rgba(255,0,0,1)",
			uppercase: false,
			letterSpacing: "1",
			textShadow: null,
		},
		item: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				marginHorizontal: "0",
				marginVertical: "0",
				backgroundColor: "rgba(255,255,255,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				marginHorizontal: "0",
				marginVertical: "0",
				backgroundColor: "rgba(255,255,255,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				marginHorizontal: "0",
				marginVertical: "0",
				backgroundColor: "rgba(255,255,255,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		subItem: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				marginHorizontal: "0",
				marginVertical: "0",
				backgroundColor: "rgba(255,255,255,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				marginHorizontal: "0",
				marginVertical: "0",
				backgroundColor: "rgba(255,255,255,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				marginHorizontal: "0",
				marginVertical: "0",
				backgroundColor: "rgba(255,255,255,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		backgroundColor: "rgba(0,0,0,1)",
		backgroundImageUrl: "",
		backgroundGradient: null,
		paddingVertical: "10",
		paddingHorizontal: "10",
	},
	lists: {
		header: {
			backgroundColor: "rgba(255,255,255,1)",
			backgroundImageUrl: "",
			backgroundGradient: null,
			paddingVertical: "5",
			paddingHorizontal: "0",
			marginVertical: "0",
			marginHorizontal: "0",
			boxShadow: null,
			borderStyle: "solid",
			borderColor: "rgba(255,255,255,1)",
			borderWidth: "0",
			borderRadius: "0",
			borderTopOn: false,
			borderRightOn: false,
			borderBottomOn: false,
			borderLeftOn: false,
			textColor: "rgba(0,0,0,1)",
			textShadow: null,
		},
		item: {
			backgroundColor: "rgba(0,0,0,0)",
			backgroundImageUrl: "",
			backgroundGradient: null,
			paddingVertical: "5",
			paddingHorizontal: "0",
			marginVertical: "0",
			marginHorizontal: "0",
			boxShadow: null,
			borderStyle: "solid",
			borderColor: "rgba(255,255,255,1)",
			borderWidth: "0",
			borderRadius: "0",
			borderTopOn: false,
			borderRightOn: false,
			borderBottomOn: false,
			borderLeftOn: false,
			textColor: "rgba(0,0,0,1)",
			textShadow: null,
		},
		footer: {
			backgroundColor: "rgba(255,255,255,1)",
			backgroundImageUrl: "",
			backgroundGradient: null,
			paddingVertical: "5",
			paddingHorizontal: "0",
			marginVertical: "0",
			marginHorizontal: "0",
			boxShadow: null,
			borderStyle: "solid",
			borderColor: "rgba(255,255,255,1)",
			borderWidth: "0",
			borderRadius: "0",
			borderTopOn: false,
			borderRightOn: false,
			borderBottomOn: false,
			borderLeftOn: false,
			textColor: "rgba(0,0,0,1)",
			textShadow: null,
		},
		separator: {
			backgroundColor: "rgba(255,255,255,0)",
			backgroundImageUrl: "",
			backgroundGradient: null,
			paddingVertical: "0",
			paddingHorizontal: "0",
			lineStyle: "solid",
			lineColor: "rgba(255,255,255,1)",
			lineWidth: "1",
			lineShadow: null,
		},
	},
	texts: {
		h1: {
			normal: {
				font: {
					family: "Lato-Bold",
					size: "24",
					italic: false,
					underline: false,
					lineHeight: "30",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato-Bold",
					size: "24",
					italic: false,
					underline: false,
					lineHeight: "30",
					color: "rgba(255,0,0,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato-Bold",
					size: "24",
					italic: false,
					underline: false,
					lineHeight: "30",
					color: "rgba(255,255,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		h2: {
			normal: {
				font: {
					family: "Lato-Bold",
					size: "18",
					italic: false,
					underline: false,
					lineHeight: "24",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato-Bold",
					size: "18",
					italic: false,
					underline: false,
					lineHeight: "24",
					color: "rgba(255,0,0,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato-Bold",
					size: "18",
					italic: false,
					underline: false,
					lineHeight: "24",
					color: "rgba(255,255,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		h3: {
			normal: {
				font: {
					family: "Lato-SemiBold",
					size: "16",
					italic: false,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato-SemiBold",
					size: "16",
					italic: false,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,0,0,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato-SemiBold",
					size: "16",
					italic: false,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,255,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		h4: {
			normal: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,0,0,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,255,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		h5: {
			normal: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,0,0,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,255,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		h6: {
			normal: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,0,0,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "16",
					italic: true,
					underline: false,
					lineHeight: "18",
					color: "rgba(255,255,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		default: {
			normal: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,0,0,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		small: {
			normal: {
				font: {
					family: "Lato",
					size: "12",
					italic: false,
					underline: false,
					lineHeight: "14",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato",
					size: "12",
					italic: false,
					underline: false,
					lineHeight: "14",
					color: "rgba(255,0,0,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "12",
					italic: false,
					underline: false,
					lineHeight: "14",
					color: "rgba(255,255,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		mini: {
			normal: {
				font: {
					family: "Lato",
					size: "10",
					italic: false,
					underline: false,
					lineHeight: "12",
					color: "rgba(255,255,255,0.75)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato",
					size: "10",
					italic: false,
					underline: false,
					lineHeight: "12",
					color: "rgba(255,0,0,0.75)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "10",
					italic: false,
					underline: false,
					lineHeight: "12",
					color: "rgba(255,255,255,0.25)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
		link: {
			normal: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			error: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,0.5)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			highlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
			lowlight: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: true,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				marginVertical: "0",
				marginHorizontal: "0",
				paddingVertical: "0",
				paddingHorizontal: "0",
				borderStyle: "solid",
				borderColor: "rgba(0,0,0,0)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				boxShadow: null,
			},
		},
	},
	controls: {
		text: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "1",
				borderTopOn: true,
				borderBottomOn: true,
				borderLeftOn: true,
				borderRightOn: true,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundGradient: null,
				boxShadow: null,
			},
			invalid: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(0,0,255,1)",
				borderWidth: "1",
				borderTopOn: true,
				borderBottomOn: true,
				borderLeftOn: true,
				borderRightOn: true,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,255,0.25)",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,0.4)",
				borderWidth: "1",
				borderTopOn: true,
				borderBottomOn: true,
				borderLeftOn: true,
				borderRightOn: true,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,0.1)",
				backgroundGradient: null,
				boxShadow: null,
			},
			focused: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(128,128,255,1)",
				borderWidth: "2",
				borderTopOn: true,
				borderBottomOn: true,
				borderLeftOn: true,
				borderRightOn: true,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		radioCheckbox: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundGradient: null,
				boxShadow: null,
			},
			invalid: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundGradient: null,
				boxShadow: null,
			},
			focused: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderTopOn: false,
				borderBottomOn: false,
				borderLeftOn: false,
				borderRightOn: false,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		picker: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "1",
				borderTopOn: true,
				borderBottomOn: true,
				borderLeftOn: true,
				borderRightOn: true,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundGradient: null,
				boxShadow: null,
			},
			invalid: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(0,0,255,1)",
				borderWidth: "1",
				borderTopOn: true,
				borderBottomOn: true,
				borderLeftOn: true,
				borderRightOn: true,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,255,0.25)",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,0.4)",
				borderWidth: "1",
				borderTopOn: true,
				borderBottomOn: true,
				borderLeftOn: true,
				borderRightOn: true,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,0.1)",
				backgroundGradient: null,
				boxShadow: null,
			},
			focused: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: false,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(128,128,255,1)",
				borderWidth: "2",
				borderTopOn: true,
				borderBottomOn: true,
				borderLeftOn: true,
				borderRightOn: true,
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
	},
	buttons: {
		primary: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,255,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,255,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,255,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		secondary: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.8)",
					uppercase: true,
					letterSpacing: "1",
					boxShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		success: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,255,0,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,255,0,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,255,0,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		danger: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,0,0,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,0,0,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,0,0,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		warning: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,193,7,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,193,7,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,193,7,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		info: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,162,185,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,162,185,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,162,185,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		light: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,1)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,0.4)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		dark: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
		textOnly: {
			enabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,1)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			disabled: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(255,255,255,0.4)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(0,0,0,0)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
			active: {
				font: {
					family: "Lato",
					size: "14",
					italic: false,
					underline: false,
					lineHeight: "16",
					color: "rgba(0,0,0,0.8)",
					uppercase: true,
					letterSpacing: "1",
					textShadow: null,
				},
				borderStyle: "solid",
				borderColor: "rgba(255,255,255,1)",
				borderWidth: "0",
				borderRadius: "0",
				paddingHorizontal: "2",
				paddingVertical: "2",
				backgroundColor: "rgba(255,255,255,0.8)",
				backgroundImageUrl: "",
				backgroundGradient: null,
				boxShadow: null,
			},
		},
	},
	shadows: null,
	card: {
		borderStyle: "solid",
		borderColor: "rgba(255,255,255,1)",
		borderWidth: "0",
		borderRadius: "10",
		backgroundColor: "rgba(255,255,255,1)",
		textColor: "rgba(0,0,0,1)",
		highlightColor: "rgba(0,0,0,1)",
		paddingHorizontal: "10",
		paddingVertical: "10",
	},
};

export default defaultTheme;
